/*
 * Controls the behaviour of the slide in/out
 * mobile menu
 *
 * @author eric.bailey@barrelny.com
 *
 */

var Views = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.penthouse-page'
		].join();

		if (!$(templates).length) return;

		var self = this;
		self.pano = self.krpano = null;
		self.toggles = '.view-toggle a';
		self.fullScreenModeSelector = '.js-full-screen'
		self.panBtns = '.ui-pan';
		self.$menus = $('#menu-header-menu, #menu-header-menu-1');

		krpanoDefaults.onready = function(){
			self.initSceneActions.call(self);
		};
		embedpano(krpanoDefaults);

	},

	initSceneActions: function() {
		var self = this, d = document;

		// cache dom elements for krpano
		self.pano = d.getElementById('pano');
		self.krpano = d.getElementById('krpanoSWFObject');

		// pano view toggle properties
		$(self.toggles).removeClass('is-active').each( function (idx){
			var $toggle = $(this), firstToggle = idx % 2 === 0;

			if ( firstToggle ) {
				$toggle.addClass('is-active');
				$toggle.attr('data-index', idx);
			}

		});
		self.fullScreenMode = (d.fullScreen||d.mozFullScreen||d.webkitIsFullScreen);
		// pano go to fullscreen mode
		$(self.fullScreenModeSelector).on('click', function (e) {
			e.preventDefault();
			self.krpano.call( 'switch(fullscreen)' );
		})
		self.events();
		self.resizePano();
	},

	events:function(){
		var self = this;

		// pano views toggle
		var viewScenes = []
		$(self.toggles).each(function () {
			viewScenes.push('krpano-view--'+this.hash.substr(1))
		})
		viewScenes = $.unique(viewScenes).join(' ')
		$(self.toggles).on('click', function (){
			var sceneName = this.hash.substr(1),
					action = 'loadscene('+sceneName+', null, null, BLEND(1))';

			self.krpano.call( action );
			$(self.toggles).removeClass('is-active');
			$(this).addClass('is-active');
			$('body').removeClass(viewScenes).addClass('krpano-view--'+sceneName)

			return false;
		});

		// pan left/right buttons
		$(self.panBtns).on('mousedown mouseup touchstart touchend', function (e){
			var normalizedEvent = e.type.indexOf('mouse') > -1 ? e.type : (
				e.type==='touchstart'?'mousedown':'mouseup'
			),
			action = "set(hlookat_moveforce,%d);";

			switch( normalizedEvent + this.hash ) {
			case "mousedown#east":
				force = "+1";
				break;
			case "mousedown#west":
				force = "-1";
				break;
			default:
				force = "0";
			}
			self.krpano.call( action.replace('%d', force) );
			return false;
		});

		// detect fullscreen mode
		$(document).on('mozfullscreenchange webkitfullscreenchange fullscreenchange', function(e){
			self.fullScreenMode = !self.fullScreenMode;
			var method = self.fullScreenMode ? 'add' : 'remove';
			$('body')[method+'Class']('fullscreen');
		});

		// resize pano viewer
		$(window).on(
			'resize',
			$.throttle( 500, self.resizePano.bind(self) )
		);
	},

	resizePano: function() {
		var self = this, d = document, w = window, h = 0,
		ph = (typeof(w.innerHeight) == 'number') ? w.innerHeight : (
			(d.documentElement && d.documentElement.clientHeight) ? d.documentElement.clientHeight : (
				(d.body && d.body.clientHeight) ? d.body.clientHeight : 500
			)
		);

		if ( $(self.$menus[0]).is(':visible') ) {
			var $menu = $(self.$menus[0]);
			h += $('.header').height();
			h += $menu.find('.current_page_item .sub-menu').height();
		} else {
			h = $(self.$menus[0]).parents('.header').height();
		}
		console.log('h:' + h)
		self.pano.style.height = (ph-h)+"px";

	},

	drop:function(){

	}
}

module.exports = Views;
